import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { load } from '../../Actions/Cart.action';
import { loadWishList } from '../../Reducers/WishList.reducer';
import { get } from '../../Services/http';
import { userInfoActions } from '../../Reducers/UserInfo.reducer';

const ClientContextLoader = () => {
    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(load());
        dispatch(loadWishList());

        get('/api/client-context/')
            .then(response => response.json())
            .then(data => {
                window.localStorage.setItem('requestVerificationToken', data.antiForgeryToken);
                dispatch(userInfoActions.updateUserInfo(data.userInfo));
            });

    }, [dispatch]);

    return null;
};

export default ClientContextLoader;